import { useMemo } from 'react';
import { useStepperContext } from './useStepperContext';

// A composable layer on top of `useStepperContext`: takes a set of validation
// rules and derives `isNextEnabled` from them. The base stepper is untouched —
// callers that don't need gating keep using `useStepperContext` directly.
//

export type StepperValidationRule = {
  isValid: boolean;
};

export function useValidatedStepper(rules: ReadonlyArray<StepperValidationRule>) {
  const stepper = useStepperContext();
  const isNextEnabled = rules.every(rule => rule.isValid);
  return useMemo(() => ({ ...stepper, isNextEnabled }), [stepper, isNextEnabled]);
}
